import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import { FormattedMessage } from 'react-intl'
import moment from 'moment'
import cx from 'classnames'
import _ from 'lodash'

import { canGenerateDistraints } from '@global/helpers'

import Toolbar from '../Toolbar'

import hocDialog from '../../../../services/dialog/hocDialog'

import { LOCALE_PREFIX } from './constants'
import { ENTITY_TYPE } from '../../../../global/constants'

import { EntityRecord } from '../../../../global/records'

import hocConnect from './hocConnect'
import './style.scss'

@hocDialog
@hocConnect
export default class Header extends Component {
    static propTypes = {
        entity: IPropTypes.recordOf(EntityRecord).isRequired,
        hasToolbar: PropTypes.bool,
        moduleKey: PropTypes.string.isRequired,
        openDialog: PropTypes.func.isRequired,
        openLinkagesById: PropTypes.func.isRequired,
        setupDistraintsById: PropTypes.func.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.moduleKey !== nextProps.moduleKey) return true
        if (this.props.hasToolbar !== nextProps.hasToolbar) return true
        if (this.props.entity && !this.props.entity.equals(nextProps.entity)) return true

        return false
    }

    handleOpenLinkages = () => {
        const { openLinkagesById, entity } = this.props

        if (!entity) return null

        const entId = entity.get('id', null)

        openLinkagesById(entId)
        return null
    }

    handleOpenDistraints = () => {
        const { setupDistraintsById, entity } = this.props

        if (!entity) return null

        const entId = entity.get('id', null)

        setupDistraintsById(entId)
        return null
    }

    handleOpenGroups = () => {
        const { openDialog, entity } = this.props

        const entId = entity.get('id', null)

        openDialog('manageGroups', `entity-${entId}-manage-groups-dialog`, { entities: [entity] })

        return null
    }

    renderLoader = () => (
        <div className={'entity-header-loader'}>
            <FormattedMessage id={`${LOCALE_PREFIX}.loading`} />
        </div>
    )

    renderHeader = () => {
        const { entity } = this.props

        const type = entity.get('type')
        const gender = entity.getIn([type, 'gender'])
        const active = entity.getIn([type, 'activity', 'active'], true)
        const country = _.lowerCase(entity.getIn(['country', 'iso2'], ''))

        const description =
            type === ENTITY_TYPE.NATURAL_PERSON ? (
                <div className={cx('texts-wrap', 'date')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.description.title.dateOfBirth`} values={{ gender }} />
                    <span>{moment(entity.getIn([type, 'dateOfBirth', 'value'])).format('DD. MM. YYYY')}</span>
                </div>
            ) : (
                <div className={cx('texts-wrap', 'regNbr')}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.description.title.regNbr`} />
                    <span>{entity.getIn([type, 'regNbr'])}</span>
                </div>
            )

        let icon = ''
        if (type === ENTITY_TYPE.CORPORATION) icon = `${type}${!active ? '-inactive' : ''}`
        else icon = `${type}${gender ? `-${gender}` : '-male'}${!active ? '-inactive' : ''}`

        return (
            <div className={cx('entity-header-content', 'icon', `type-${icon}`)}>
                <div className={cx('flag-icon', `flag-icon-${country}`)} />
                <div className={'basic-info'}>
                    <div className={'name'} title={entity.get('name', '')}>
                        {entity.get('name', '')}
                    </div>
                    <div className={'controls'}>
                        <div className={'description'}>{description}</div>
                        {!_.isNil(type) && type !== ENTITY_TYPE.NATURAL_PERSON && (
                            <button className={'entity-header-control-btn groups'} onClick={this.handleOpenGroups}>
                                <FormattedMessage id={`${LOCALE_PREFIX}.showGroups`} />
                            </button>
                        )}
                        <button className={'entity-header-control-btn linkages'} onClick={this.handleOpenLinkages}>
                            <FormattedMessage id={`${LOCALE_PREFIX}.showLinkages`} />
                        </button>
                        {canGenerateDistraints(entity.get('country', Map()).get('iso2', null)) && (
                            <button
                                className={'entity-header-control-btn distraints'}
                                onClick={this.handleOpenDistraints}
                            >
                                <FormattedMessage id={`${LOCALE_PREFIX}.checkDistraints`} />
                            </button>
                        )}
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { entity, hasToolbar } = this.props

        return (
            <div className={'entity-header'}>
                {entity.get('id') > 0 ? this.renderHeader() : this.renderLoader()}
                <div className={'toolbar-container'}>
                    <Toolbar entity={entity} show={hasToolbar} />
                </div>
            </div>
        )
    }
}
